import {EventEmitter, Injectable, Output} from '@angular/core';
import {ModalController, Modal} from 'ionic-angular';
import {ImageListingModalComponent} from '../../../../shared/components/image-listing-modal';

/**
 * Class for the ImageSearch
 * @class
 */
@Injectable()
export class ImageSearch {
  /**
   * @constructor
   * @param {ModalController} modalCtrl
   */
  constructor(public modalCtrl: ModalController) {
  }

  /**
   * Create the image listing modal
   * @returns {void}
   */
  doImageListingModal(): Modal {
    const imageListingModal = this.modalCtrl.create(ImageListingModalComponent, {}, {showBackdrop: false});
    imageListingModal.present();
    return imageListingModal;
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/services/image-search/image-search.service.ts